import { PermissionsGroupsSelector } from './PermissionsGroupsSelector';

export * from './PermissionsGroupsSelector';
export default PermissionsGroupsSelector;
